/*
 Google

 OAuth2 dla Google
  
 historia: 
  PM 2021-11-18 - start
*/

import * as React from 'react';
import { getHashToken, oauth2SignInGoogle } from '../../oauth2';

import DialogError from '../DialogError';

interface GoogleState {
    error: boolean,
}

class Google extends React.Component<any, GoogleState> {

    constructor(props: any) {
        super(props, {});

        this.state = {
            error: false
        }
    }

    //PM 2021-11-29
    //usuniecie "/" przed "#"
    componentDidMount = () => {
        const accessToken = getHashToken()
        const redirectUrl = sessionStorage.getItem("redirect_url")

        if (accessToken && redirectUrl)
            window.open(`${redirectUrl}#access_token=${accessToken}`, '_self')
        else {
            const hrefParams = window.location.href.split('?')[1]
            if (hrefParams) {
                const hrefParamsSplit = hrefParams.split('=')

                if (hrefParamsSplit[0] === 'redirect_url' && hrefParamsSplit[1]) {
                    sessionStorage.setItem("redirect_url", hrefParamsSplit[1])
                    oauth2SignInGoogle()
                }
                else
                    this.setState({ error: true })
            }
            else
                this.setState({ error: true })
        }
    }

    render() {

        return (
            <DialogError error={this.state.error} />
        );
    }
}

export default Google;
